import { Box, styled, Typography, type BoxProps } from '@mui/material';

export const StyledOptionBox = styled(Box)<BoxProps>(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5)
}));

export const StyledOptionRow = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
}));

export const StyledLeftGroup = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4)
}));

export const StyledDetailColumn = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
}));

export const StyledDateColumns = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'flex-start'
}));

export const StyledDateValues = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end'
}));

export const StyledDetailText = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary
}));
